import { ky } from './ky';

export interface Region {
  area0: string; // 국가 정보
  area1: string; // 행정구역 단위 (시/도)
  area2: string; // 행정구역 단위 (구/군)
  area3: string; // 행정구역 단위 (동/읍/면)
  area4: string; // 리 정보
}

export interface ReverseGeocodingResult {
  name: string;
  region: Region;
}

export interface ReverseGeocodingResponse {
  status: string;
  results: ReverseGeocodingResult[];
}

export default class MapService {
  async reverseGeocoding(latitude: number, longitude: number): Promise<ReverseGeocodingResponse> {
    return await ky.get('v1/maps/reverse-geocoding', {
      searchParams: {
        latitude,
        longitude,
      },
    }).json() as ReverseGeocodingResponse;
  }
}
